import Image from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { MegaphoneIcon } from "@heroicons/react/24/solid";
import { Upsells } from "../types";
import { joinClassNames } from "@utils/helpers";
import { useIsShopsite } from "@context/DomainContext";
import { Heading, Text } from "@components/theming";

interface Props {
  events: Upsells[];
}

const UpsellEvents = ({ events }: Props) => {
  const t = useTranslations("Checkout.Cart.upsells");
  const isShopsite = useIsShopsite();

  return (
    <div className="mt-10">
      <Heading className="text-3xl sm:text-5xl font-black">
        {t("youmightlike")}
      </Heading>

      <div className="mt-8 flex gap-6 w-full overflow-x-scroll">
        {events.map((event, index) => (
          <Link
            key={`${event.Title}-${index}`}
            href={event.Url}
            className={joinClassNames(
              "flex flex-col items-start gap-1 p-2 w-[12.5rem] rounded-2xl transition-colors ease-in-out duration-500",
              isShopsite
                ? "hover:bg-indigo-50/75"
                : "hover:bg-[color:var(--accent-a3)]"
            )}
          >
            {event.ImageUrl ? (
              <Image
                src={event.ImageUrl.trim()}
                alt={event.Title}
                placeholder={"empty"}
                width={192}
                height={224}
                className="object-cover w-full aspect-[6/7] rounded-xl"
              />
            ) : (
              <div
                className={joinClassNames(
                  "flex items-center justify-center w-full aspect-[6/7] rounded-xl",
                  isShopsite ? "bg-indigo-50" : "bg-[color:var(--accent-a2)]"
                )}
              >
                <MegaphoneIcon
                  className={joinClassNames(
                    "w-1/2 h-1/2",
                    isShopsite
                      ? "text-indigo-800"
                      : "text-[color:var(--accent-11)]"
                  )}
                />
              </div>
            )}
            <Text as="p" sharedClasses="text-lg font-semibold">
              {event.Title}
            </Text>
            <div
              className="flex-1"
              dangerouslySetInnerHTML={{
                __html: `${event.Header}${event.Footer}`,
              }}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default UpsellEvents;
